import { API_AUTH_RESEND_VERIFICATION } from '@/shared/constants/bff-endpoints';


type ResendVerificationParams = {
    email: string;
};

type ResendVerificationResult =
    | { success: true }
    | { success: false; error: string };


export const resendVerification = async (
    params: ResendVerificationParams,
): Promise<ResendVerificationResult> => {
    try {
        const response = await fetch(
            API_AUTH_RESEND_VERIFICATION,
            {
                method : 'POST',
                headers: { 'Content-Type': 'application/json' },
                body   : JSON.stringify({ email: params.email }),
            },
        );

        if (!response.ok) {
            return { success: false, error: 'Failed to resend verification email' };
        }

        return { success: true };
    } catch {
        return { success: false, error: 'Network error' };
    }
};
